import { render } from "./listopen.vue?vue&type=template&id=5c601148"
import script from "./listopen.vue?vue&type=script&lang=js"
export * from "./listopen.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__